import { render, staticRenderFns } from "./PledgeOrderView.vue?vue&type=template&id=22cbfc5f"
import script from "./PledgeOrderView.vue?vue&type=script&lang=js"
export * from "./PledgeOrderView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports